import { render, staticRenderFns } from "./CurrenciesPaymentsHistory.vue?vue&type=template&id=7a3edda5&scoped=true"
import script from "./CurrenciesPaymentsHistory.vue?vue&type=script&lang=js"
export * from "./CurrenciesPaymentsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3edda5",
  null
  
)

export default component.exports